module.exports = __webpack_public_path__ + "img/banana-mobile-wh.7ee3be6d.svg";